import { GetAssignmentsForAssignableResponse, JobAssignee } from '@eigtech/assignments-types'
import { useMemo } from 'react'
import { useGetAssignmentsForClaim } from './getAssignmentsForClaim'

export type UseGetJobsForClaimProps = {
  claimNumber: string
}

export function useGetJobsForClaim({ claimNumber }: UseGetJobsForClaimProps) {
  const query = useGetAssignmentsForClaim(claimNumber)

  return useMemo(
    () => ({
      query,
      jobs: getJobsForClaim({ assignments: query.data }),
    }),
    [query]
  )
}

export type GetJobsForClaimProps = {
  assignments: GetAssignmentsForAssignableResponse | undefined
}

export function getJobsForClaim({ assignments }: GetJobsForClaimProps) {
  return assignments
    ?.filter((assignment) => assignment.assignable.assigneeRelationship === 'job')
    .map((assignment) => (assignment.assignee as JobAssignee).job)
}
